import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device } from '@helpers/media';
import { paragraphMedium, paragraphSmall } from '@helpers/typography';
import { horizontalFadeIn } from '@helpers/variants';
import Pill from '@stories/Components/Pill/Pill';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Container = styled(m.a).attrs(() => ({
    variants: horizontalFadeIn(-25),
})) `
  display: flex;
  flex-direction: column;
  gap: 15px;
  cursor: pointer;
  margin: ${fluidAdjusted(20, 35, Device.Mobile, Device.ActualDesktop)} 0px;
  padding: ${fluidAdjusted(20, 35, Device.Mobile, Device.ActualDesktop)} 0px;
  border-bottom: 2px solid #ded1c3;
  text-decoration: none;
  color: ${brand.black};

  &:first-child {
    margin-top: 0;
  }
`;
const TopBar = styled.div `
  display: flex;
  justify-content: space-between;
`;
const Date = styled.div `
  ${paragraphSmall}
  font-weight: 700;
  margin-left: auto;
`;
const ThemedPill = styled(Pill) `
  ${({ colour }) => css `
      background-color: ${colour};
    `};
`;
const Title = styled.div `
  ${paragraphMedium}
  margin: 0;
  font-weight: 800;
`;
const Content = styled.div `
  ${paragraphSmall}
  margin: 0;
  font-weight: 100;
`;
const FakeCta = styled.div `
  ${paragraphSmall}
  margin: 0;
  width: max-content;
  color: ${brand.black};
  display: grid;
  grid-template-columns: max-content 15px;
  gap: 8px;
  align-items: center;
  font-weight: 900;
  max-width: 100%;
  border-bottom: 2px solid ${brand.black};

  svg {
    max-height: 15px;
  }
`;
export const SearchResultCardStyles = {
    Container,
    TopBar,
    Date,
    ThemedPill,
    Title,
    Content,
    FakeCta,
};
